import { createListenerMiddleware } from '@reduxjs/toolkit';

export const appListener = createListenerMiddleware();
